module.exports = __webpack_public_path__ + "static/media/sidebar-2.d6da0dcc.jpg";